import Breadcrumbs from "components/Common/Breadcrumb"
import Mdatatable from "components/Datatables/Mdatatables"
import { get } from 'helpers/api_helper'
import { userModuleData } from 'helpers/basic_helper'
import { CLIENT_URL } from "helpers/url_helper"
import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import {
    Card,
    CardBody,
    Col,
    Container,
    Row
} from "reactstrap"
import Datatables from "components/Datatables/datatable";
import { Link } from "react-router-dom";

const isType = 'client'

const Blocked = () => {
    const [dataRows, setDataRows] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [isActions, setIsActions] = useState(false)
    const [isActionColumn, setIsActionColumn] = useState(false)
    const [error, setError] = useState(false);
    const [pagination, setPagination] = useState({
        limit: 10,
        page: 1,
        search: ''
    })
    
    useEffect(() => {
        const handler = setTimeout(() => {
            getData();
        }, 300);

        return () => clearTimeout(handler);
    }, [pagination]);
    

    const getData = async() => {
        setIsLoading(true)
        const {status, response} = await get(`${CLIENT_URL}/blocked?page=${pagination?.page}&limit=${pagination?.limit}&search=${pagination?.search}`);
        if(status == 200){
            setDataRows(response);
        }

        setIsLoading(false)
        if(status === undefined){
            setError(true)
        }
    }

    const handleStatus = async(ID, status) => {
        setIsLoading(ID)
        const res = await get(`${CLIENT_URL}/unblock/${ID}/${status}`);
        if(res.status) {
            setIsLoading(false)
            getData()
        }
    }

    // table Column Data
    let datatableData = [
        {
            dataField: 'id',
            text: 'Id'
        },{
            dataField: 'clientname',
            text: 'Client Name'
        },{
            dataField: 'code',
            text: 'Client Code'
        },{
            dataField: 'mobile',
            text: 'Mobile'
        },{
            dataField: 'state_title',
            text: 'State'
        },{
            dataField: 'country_title',
            text: 'Country'
        },{
            dataField: 'city_title',
            text: 'City'
        },{
            dataField: 'station_title',
            text: 'Station'
        }, {
            dataField: 'action',
            text: 'Action',
            isDummyField: true,
            formatter: (cell, row) => <Link to="#" className={`btn ${row.status == 2 ? "btn-danger" : "btn-success"} btn-sm`} onClick={() => handleStatus(row.id, row.status == 2 ? 0 : 2)} title={row.status == 2 ? "Un-Block" : "Block"} > <i className={`fas ${row.status == 2 ? "fa-lock" : "fa-unlock"}`} /> </Link>
        }
    ];

    useEffect(async() => {
        const data =  await userModuleData('client_master', 'blocked_client')
        setIsActions(data)
        if(data && (data?.cub)){
            data.isBlocking = true;
            setIsActionColumn(true)
        }
    }, [])

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Dashboard | {isType}</title>
                </MetaTags>
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumbs
                        pageTitle="Masters"
                        title="Masters"
                        breadcrumbItem="Clients"
                    />

                    <Row>
                        <Col xl="12">
                            <Card>
                                <CardBody>
                                    <Datatables 
                                        isSearch={true}
                                        columns = {datatableData}
                                        showTableOnly={true}
                                        rowsLength = {dataRows?.total_rows || 0}
                                        rows = {dataRows?.rows || []}
                                        keyField={'id'}
                                        handleAddButton={()=>{
                                            setEditableObj(null)
                                            isOpen(true)
                                        }}            
                                        title = "All Blocked Clients"
                                        loading={isLoading}
                                        isAdd = {true}
                                        isTableHead = {true}
                                        ssr={setPagination}
                                    />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default Blocked
